<template>
  <div
    class="banner-container"
    v-if="list.length"
  >
    <div
      class="swiper-wrap"
      v-swiper="swiperOption"
    >
      <div class="swiper-wrapper">
        <div
          class="swiper-slide"
          v-for="(banner, index) in list"
          :key="index"
        >
          <div
            class="banner-item"
            :style="{
              background:
                'url(\'' + banner + '\') center/cover no-repeat',
            }"
          ></div>
        </div>
      </div>
    </div>

    <svg
      class="icon button-prev button"
      aria-hidden="true"
    >
      <use xlink:href="#icon-zuo"></use>
    </svg>

    <svg
      class="icon button-next button"
      aria-hidden="true"
    >
      <use xlink:href="#icon-you"></use>
    </svg>
  </div>
</template>

<script>
import Vue from 'vue'

if (process.client) {
  const VueAwesomeSwiper = require('vue-awesome-swiper')
  Vue.use(VueAwesomeSwiper)
}

export default {
  props: {
    list: {
      type: Array,
      default: () => []
    }
  },
  watch: {
    list: {
      immediate: true,
      deep: true,
      handler (newValue, oldValue) {
        this.swiperOption = {
          threshold: 10,
          speed: 400,
          loop: true,
          direction: 'horizontal',
          paginationClickable: true,
          autoplay: this.list && this.list.length > 1 ? {
            delay: 5000,
            disableOnInteraction: false
          } : false,
          navigation: {
            nextEl: '.button-next',
            prevEl: '.button-prev'
          }
        }
      }
    }
  },
  data () {
    return {
      swiperOption: {
        threshold: 10,
        speed: 400,
        loop: true,
        direction: 'horizontal',
        paginationClickable: true,
        autoplay: {
          delay: 5000,
          disableOnInteraction: false
        },
        navigation: {
          nextEl: '.button-next',
          prevEl: '.button-prev'
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.banner-container {
  position: relative;
  margin-top: 25px;
  width: 100%;
  height: 500px;
  color: #fff;

  .swiper-wrap {
    overflow: hidden;
  }

  ::v-deep .swiper-container {
    height: 100%;
  }

  .banner-item {
    height: 100%;
  }

  .button {
    position: absolute;
    top: 240px;
    z-index: 100;
    color: #5e5e5e;
    font-size: 24px;
    cursor: pointer;
  }

  .button-prev {
    left: -66px;
  }

  .button-next {
    right: -66px;
  }

  .button-disabled {
    color: #ccc;
    cursor: default;
  }
}
</style>
